import { Text } from '@mantine/core';
import { BackButton } from 'components/shared';
import { Fragment } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useIntegration, useUpdateIntegration } from 'utils/integrations';
import IntegrationForm from 'components/IntegrationsDashboard/IntegrationForm';

const EditIntegration = () => {
  const { apiId } = useParams();
  const [editIntegration] = useUpdateIntegration();
  const { data: integrationData } = useIntegration(apiId);
  const integration = integrationData?.Api;
  const navigate = useNavigate();

  if (!integration) {
    return <Text>Loading....</Text>;
  }

  return (
    <Fragment>
      <BackButton onClick={() => navigate('/api/list')}>{'<'} Back to all APIs</BackButton>
      <IntegrationForm
        action="UPDATE"
        integration={integration}
        onSubmit={api => editIntegration({ variables: { api: { ...api, id: apiId } } })}
      />
    </Fragment>
  );
};

export default EditIntegration;
